export default "__VITE_ASSET__bQ1RXJ7j__"